export interface Blooper {
  id: string;
  icon: string;
  title: string;
  tag: string;
  desc: string;
}

export const bloopers: Blooper[] = [
  {
    id: "b1",
    icon: "ri-book-2-line",
    title: "从网络连载到大银幕",
    tag: "原著改编",
    desc: "影片改编自网络连载小说，原著以第一人称、口语化的方式记录年轻人的经历。编剧在改编时保留了大量的自述式旁白，让电影始终带着“有人在跟你讲他自己的故事”的温度。",
  },
  {
    id: "b2",
    icon: "ri-user-voice-line",
    title: "导演身兼主演",
    tag: "幕后人员",
    desc: "导演胡耀辉同时兼任编剧与演员，在片中出演主要角色之一。这种身兼数职的做法，让创作意图在表演层面被更直接地贯彻，也让整部片带有明显的作者气质。",
  },
  {
    id: "b3",
    icon: "ri-map-pin-2-line",
    title: "城市与旅途的双线取景",
    tag: "取景与拍摄",
    desc: "影片的取景横跨香港、英国与内地的多座城市。不同地点承担不同的叙事任务：香港是来处，异乡是冲击，旅途是试炼。场景的切换本身就是主角心态变化的外化。",
  },
  {
    id: "b4",
    icon: "ri-music-2-line",
    title: "配乐与情绪的落差",
    tag: "声音设计",
    desc: "影片在热闹段落使用节奏明快的配乐，到了反思段落则几乎抽掉音乐，只留下环境声与独白。这种“声音上的留白”，是它能在喜剧外壳下留住情绪的重要手段。",
  },
];

export interface EasterEgg {
  id: string;
  index: string;
  title: string;
  desc: string;
}

export const easterEggs: EasterEgg[] = [
  {
    id: "e1",
    index: "01",
    title: "开头与结尾的旁白呼应",
    desc: "同一个口吻、相似的句子，在开头和结尾各出现一次。开场时听是少年人的得意，收尾时再听却变成了自嘲。留意语气上的差别，就能读懂这趟旅程对主角意味着什么。",
  },
  {
    id: "e2",
    index: "02",
    title: "反复出现的车窗镜头",
    desc: "向西每一次心态转变之前，几乎都伴随一个从车内向外望的镜头。窗外景物从熟悉到陌生、再到熟悉，暗示着他正在经历的坐标变化。",
  },
  {
    id: "e3",
    index: "03",
    title: "好友台词里的双关",
    desc: "王静和占士的不少台词表面在开玩笑，实际都在提前给观众提示后续的剧情转折。第一次看容易当成段子，二刷时会发现它们出现的时机都太“刚好”。",
  },
  {
    id: "e4",
    index: "04",
    title: "场景里重复出现的旧物件",
    desc: "某种随身物件在少年时期、异乡求学与旅途中都出现过。它不承担直接的剧情功能，却像一条隐线，把主角不同阶段的状态串成了一条完整的时间轴。",
  },
  {
    id: "e5",
    index: "05",
    title: "被环境声遮住的一句台词",
    desc: "在几个关键的情绪转折点上，人物真正想说的话往往被背景噪声盖过。这不是收音失误，而是刻意设计——很多没说出口的话，才是故事真正的重点。",
  },
];

export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    id: "f1",
    question: "这是一部什么样的电影？",
    answer:
      "它是一部 2012 年上映的香港电影，类型上属于喜剧与爱情的结合，整体带有强烈的自传与黑色幽默色彩。影片用轻松的叙事方式，讲述一个年轻人在欲望与情感之间的迷茫与成长。",
  },
  {
    id: "f2",
    question: "本站主要提供哪些内容？",
    answer:
      "本站围绕“剧情相关延伸”整理内容，包括剧情脉络、深度解说、影评观点、经典片段、幕后花絮与彩蛋细节六大类。你可以按导航逐段阅读，也可以只挑感兴趣的部分查看。",
  },
  {
    id: "f3",
    question: "适合什么年龄观看？",
    answer:
      "影片在香港属三级片，含有成人题材与相关表达，仅适合成年观众。未满十八岁不建议观看，本站内容同样面向成年读者，并在描述上尽量克制、侧重剧情与主题分析。",
  },
  {
    id: "f4",
    question: "没看过电影能看懂本站内容吗？",
    answer:
      "可以。剧情脉络部分按时间顺序完整梳理了故事走向，解说与影评则分别从主题和评价角度展开。即使只看本页，也能对影片讲什么、好在哪、争议在哪形成一个整体印象。",
  },
  {
    id: "f5",
    question: "页面上的片段与花絮是真实视频吗？",
    answer:
      "本页是内容介绍型页面，片段与花絮部分以文字说明与主题配图的形式呈现，说明每个桥段在故事中的位置与作用，并不提供在线播放。“经典片段”中的标签可按主题筛选查看。",
  },
  {
    id: "f6",
    question: "影片有原著吗？",
    answer:
      "有的。影片改编自网络连载小说，原作者以第一人称的方式记录了一个年轻人的经历与心绪。电影在改编时保留了这种自述感，也因此比一般类型片多了一层真实的质地。",
  },
];